import React from "react";

const DEFAULT_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_power-energy-pro/artifacts/bcgoc9pi_upscalemedia-transformed.webp";

export function Logo({ src = DEFAULT_LOGO, height = 44, className = "", dark = false }) {
  // En fondos oscuros, forzamos el logo a blanco monocromático para
  // asegurar contraste (la tipografía original es azul marino).
  const darkFilter = dark ? "brightness(0) invert(1)" : undefined;
  return (
    <img
      src={src || DEFAULT_LOGO}
      alt="POWER & ENERGY"
      style={{ height, width: "auto", filter: darkFilter }}
      className={`object-contain ${className}`}
      data-testid="pe-logo"
    />
  );
}

export function ServiceBar({
  text = "SUBESTACIONES · PROYECTOS · OBRA CIVIL · GESTORÍA · UVIES · INSTALACIONES · MANTENIMIENTO",
  className = "",
}) {
  return (
    <div className={`pe-services-bar ${className}`} data-testid="pe-services-bar">
      {text}
    </div>
  );
}

export default Logo;
